export const killEvent = (e: React.SyntheticEvent<HTMLElement>): void => {
    if (e) {
        e.stopPropagation();
        e.preventDefault();
    }
};



// WEBPACK FOOTER //
// ./src/utils/domUtils.ts